import { render } from "./MonthDetail.vue?vue&type=template&id=0da081a0&scoped=true"
import script from "./MonthDetail.vue?vue&type=script&lang=js"
export * from "./MonthDetail.vue?vue&type=script&lang=js"

import "./MonthDetail.vue?vue&type=style&index=0&id=0da081a0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0da081a0"]])

export default __exports__